import { HealthblocksMemberContext } from '../../context/healthblocks-member.context'
import { useMember } from '../../hooks/useMember'

import type { ReactNode } from 'react'

type HealthblocksMemberProviderProps = {
  children: ReactNode
}

const HealthblocksMemberProvider = ({ children }: HealthblocksMemberProviderProps) => {
  const {
    member,
    clearMember,
    getMember: { execute: getMember, isLoading: getMemberLoading },
    updateMember: { execute: updateMember, isLoading: updateMemberLoading },
  } = useMember()

  return (
    <HealthblocksMemberContext.Provider
      value={{
        member: member,
        clearMember,
        getMember: getMember,
        updateMember: updateMember,
        getMemberIsLoading: getMemberLoading,
        updateMemberIsLoading: updateMemberLoading,
      }}
    >
      {children}
    </HealthblocksMemberContext.Provider>
  )
}

export { HealthblocksMemberProvider }
